const {Vue, jQuery: $} = window;

import {
	generateBuilderUI,
	leadFormData
} from "../_utilities";
import { ACTIONS } from "../_actions";
import {store, store$} from "../_config-store";
import { localize } from "../_localize.js";

const viewOptions$ = store$
	.map(state => state.viewOptions);

export const options = {
	template:
	`<div id="quote-summary">
		<section v-for="viewOption in viewOptions" v-if="viewOption.name">
			<h6>{{local(viewOption.name)}}</h6>
			<ul>
				<li v-for="option in availableOptions(viewOption.name)" v-if="option.label">
					<div>{{option.label}}</div>
					<div>{{childLabels(option)}}</div>
				</li>
			</ul>
			<button edit @click="edit(viewOption.name)"></button>
		</section>
		<label v-html="disclaimer"></label>
	</div>`,
	subscriptions: function() {
		return {
			viewOptions: viewOptions$,
			store: store$
		}
	},
	computed: {
		disclaimer(){
			return this.leadForm ? this.leadForm.MaterialsDisclaimer : this.local('Colors and materials are for reference only. Actual selection options may vary. See your Freightliner Trucks dealership for complete details.');
		},
	},
	data() {
		return {
			leadForm: leadFormData(),
			local(str){
				return str;
			}
		}
	},
	methods: {
		availableOptions: function(view) {
			return generateBuilderUI(this.store,view);
		},
		childLabels(option){
			return _.isPlainObject(option.options)
				? _.chain(option.options).map(o => {
					return o
						? `${o.altWorkflow ? `${o.altWorkflow === o.label ? o.parent : o.label}: ` : ''}${o.current}`
						: false;
				}).compact().value().join(' / ')
				: option.current;
		},
		edit: function(view){
			store.dispatch({
				type: ACTIONS.ACTIVE_SUMMARY_CHANGE,
				data: false
			});
			store.dispatch({
				type: ACTIONS.VIEW_OPTION_CHANGE,
				data: view
			});
		},
	},
	created(){
		localize().then( local => this.local = local );
	}
}


Vue.component('quote-summary',options);